import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'hooks/use-redux'
import { useNavigate } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import type { Artist, ArtistId } from 'types/artist'
import type { State } from 'types/redux'
import { SHOWCASES } from '@disco/constants/FeatureTypes'
import { getArtist } from '@disco/state-management/selectors/artists'
import { useFeatureEnabled } from '@disco/state-management/selectors/business'
import ArtistShowcases from 'components/modals/artist/showcases'
export default (): React.ReactNode => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const params = useParams<{ artistId: string }>()
  const artistId: ArtistId = parseInt(params.artistId!, 10)
  const showcasesEnabled: boolean = useFeatureEnabled(SHOWCASES)
  const artist: Artist = useSelector((state: State) =>
    getArtist(state, artistId),
  )
  useEffect(() => {
    if (!showcasesEnabled) {
      navigate(`/explorer/artists/${artistId}`)
    }
  }, [showcasesEnabled])
  return artist && <ArtistShowcases artist={artist} />
}
